import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { SiteConfigManager } from '@atlas/core';

import { PLATFORM_TYPES } from 'common/constants';

import { defaultRoutes } from '../MainRouter/constants';

import VirtualGameModal from './VirtualGameModal';

const { casino, virtualGame } = defaultRoutes;
const { MOBILE, MULTIPLATFORM } = PLATFORM_TYPES;

const VirtualGame = () => {
  const [subpages, setSubpages] = useState([]);
  const [navigationItemName, setNavigationItemName] = useState();
  const { push: historyPush } = useHistory();

  const navigationItems = SiteConfigManager.getConfig('navigation.top', []);

  useEffect(() => {
    if (navigationItems) {
      const virtualGamesArray = navigationItems
        .filter(item => virtualGame === item.location)
        .map(item => ({
          ...item,
          children: item.children.filter(
            child => child.platform_type === MULTIPLATFORM || child.platform_type === MOBILE,
          ),
        }));

      if (virtualGamesArray.length && virtualGamesArray[0].children.length) {
        setNavigationItemName(virtualGamesArray[0].name);
        setSubpages(virtualGamesArray[0].children);
      } else {
        historyPush(casino);
      }
    }
  }, []);

  if (subpages.length > 0) {
    return <VirtualGameModal name={navigationItemName} subpages={subpages} />;
  }

  return null;
};

export default VirtualGame;
